import { parseJson } from './index';

// BL-1421: the "Bioland 1" breadcrumb button links a migrated page back to its old site.
// field_migrated holds the Bioland 1 node as JSON; anything else (for example test data) has no link.
export const bioland1Url = (siteCode, fieldMigrated) =>
  {
    const nid = Number(parseJson(fieldMigrated)?.drupal_internal__nid);

    if(!siteCode || !Number.isInteger(nid) || nid <= 0) return '';

    return `https://${siteCode}.chm-cbd.net/node/${nid}`;
  };

// Biosafety Land sites never had a Bioland 1, so the button shows only on other sites with a link.
export const showBioland1Link = ({ enabled, isBiosafetySite, link }) =>
  Boolean(enabled && !isBiosafetySite && link);
